<template>
	<div class="intro" v-cloak>
		<!-- 解决手机端强制横屏后，一进入页面，本页在最底部的BUG -->
		<div id="top"></div>
		<div class="intro_top_word">
			<div class="intro_white_bg"></div>
			<div class="intro_top_word_body animated fadeInRightBig">
				<div class="intro_top_title">
					<span class="intro_name">{{ isResume ? '李女士' : 'F.U.N' }}</span>
					<span class="intro_birth">
						<span class="sm_word">1992</span>
						<span class="lg_word">年</span>
					</span>
					<span class="intro_content">集UI设计、前端开发技能于一体，工作以来所有技能皆是自学所得</span>
				</div>
				<div class="intro_top_content">
					<div class="intro_top_row row_space_between" v-for="(item, index) in selfEvaluation.contents"
						:key="index">
						<div class="left">{{index + 1}}</div>
						<div class="right" v-html="item"></div>
					</div>
				</div>
			</div>
		</div>
		<!-- 装饰图 -->
		<div class="animated fadeInLeftBig">
			<img :src="require(`@/assets/intro_img_1.png`)" class="intro_img_1">
			<img :src="require(`@/assets/intro_img_2.png`)" class="intro_img_2">
		</div>

		<div class="intro_others">
			<div class="intro_img_3_wrap animated fadeInUpBig">
				<img :src="require(`@/assets/intro_img_3.png`)" class="intro_img_3">
			</div>
			<div class="intro_middle row_space_between margin_side animated fadeInUpBig">
				<div class="intro_middle_block">
					<div class="intro_title_1">
						<span class="intro_title_txt">{{ hobbies.tit }}</span>
						<span class="intro_title_line"></span>
					</div>
					<div class="intro_tag_wrap" v-for="(item, index) in hobbies.content[0]" :key="index">
						<span class="left">{{ item.tip }}：</span>
						<span class="right">{{ item.detail }}</span>
					</div>
				</div>

				<div class="intro_middle_block center">
					<div class="intro_title_1">
						<span class="intro_title_txt">联系方式</span>
						<span class="intro_title_line"></span>
					</div>
					<div class="">
						<img v-lazy="require(`@/assets/intro_img_4.png`)" class="intro_img_4">
					</div>
				</div>
				<div class="intro_middle_block">
					<div class="intro_title_1">
						<span class="intro_title_txt">{{ education.tit }}</span>
						<span class="intro_title_line"></span>
					</div>
					<div class="intro_tag_wrap" v-for="(item, index) in education.content[0]" :key="index">
						<span class="left">{{item.tip}}：</span>
						<span class="right">{{item.detail}}</span>
					</div>
				</div>
			</div>

			<div class="intro_bottom">
				<div class="intro_bottom_bg"></div>
				<div class="intro_resume margin_side">
					<div class="intro_title_2">
						<div class="intro_title_inner">
							<div class="intro_title_lg_word">{{ isResume ? 'RESUME' : 'SYNTHETICAL' }}</div>
							<div class="intro_title_1">
								<span class="intro_title_txt">{{ isResume ? '简历' : '综合' }}</span>
								<span class="intro_title_line"></span>
							</div>
						</div>
						<div class="intro_title_2_line"></div>
					</div>
					<div class="intro_jobs" v-if="isResume">
						<div class="intro_title_3">
							<span class="intro_title_3_line"></span>
							<span>{{ workExperience.tit }}</span>
						</div>
						<div class="intro_job_body row_space_between">
							<div class="intro_job_block" v-for="(company, index) in workExperience.content"
								:key="index">
								<div class="intro_tag_wrap" v-for="(item, itemIndex) in company" :key="itemIndex">
									<span class="left">{{ !isResume && itemIndex === 0 ? item.tip2 : item.tip }}：</span>
									<span class="right" :class="{blue: itemIndex === 0}"
										v-html="!isResume && itemIndex === 0 ? item.detail2 : item.detail"></span>
								</div>
							</div>
						</div>
					</div>

					<div class="intro_skills">
						<div class="intro_title_1 center">
							<span class="intro_title_txt">{{ skills.tit }}</span>
							<span class="intro_title_line"></span>
						</div>
						<div class="intro_skills_wrap row_space_between">
							<div class="intro_skills_block" v-for="(skill, index) in skills.content" :key="index"
								:class="{yellow: skill[1].detail > 85}">
								<div class="intro_tag_wrap">
									<span class="right blue">{{skill[0].detail}}</span>
								</div>
								<div class="intro_tag_wrap row_space_between">
									<span class="left">{{ skill[1].tip }}：</span>
									<span class="right">{{skill[1].detail}}% <span
											class="intro_tag">{{getSkillLevel(skill[1].detail)}}</span></span>
								</div>
								<div class="bar">
									<div class="bar_inner" :style="{width:`${skill[1].detail}%`}"></div>
								</div>
							</div>
						</div>
					</div>

					<div class="intro_items">
						<div class="item_title row_space_between">
							<div class="intro_title_3">
								<span class="intro_title_3_line"></span>
								<span>{{ projects.tit }}（{{ projects.content.length }}个）</span>
							</div>
							<div class="intro_tab_wrap" id="tab">
								<span :class="{active: activeTab === 'mixed'}" @mouseover="changeTab('mixed')"
									@click="changeTab('mixed')">复合型({{ mixedProjectsCount }}个)</span>
								<span :class="{active: activeTab === 'ui'}" @mouseover="changeTab('ui')"
									@click="changeTab('ui')">纯UI({{ uiProjectsCount }}个)</span>
							</div>
						</div>
						<div class="intro_job_body" :class="{'two': activeTab === 'ui'}"
							v-if="visibleProjects.length > 0">
							<div class="intro_job_block row_space_between" v-for="(project, index) in visibleProjects"
								:key="index">
								<div style="width: 100%;">
									<div class="intro_tag_wrap" v-for="(item, itemIndex) in project" :key="itemIndex"
										v-if="item.tip !== '作品演示'">
										<span class="left" v-if="item.tip !== '作品展示'">{{ item.tip }}：</span>
										<span class="tag yellow"
											:class="{'yellow': tag === 'UI', 'green': tag === 'FE', 'tag_blue': tag === 'WD'}"
											v-for="(tag, idx) in item.detail.split('|')"
											v-if="item.tip.indexOf('负责标签') > -1">{{ tag }}</span>

										<div class="project_img_wrap" v-if="item.img"
											v-for="(picSrc, picIdx) in item.img" :key="picIdx">
											<img v-lazy="`./static/smPicImgs/${picSrc}`" alt="" class="project_img"
												@click="openProjectLightbox(project, picIdx)" />
										</div>

										<span class="right" :class="{blue: itemIndex === 0}" v-html="item.detail"
											v-if="item.tip.indexOf('负责标签') === -1"></span>
									</div>
								</div>
								<video v-if="project.some(item => item.video)" id="wordVideo" class="word_video"
									autoplay="autoplay" :src="project.find(item => item.video).video" loop="loop" muted
									controls="controls"></video>
							</div>
						</div>

						<div class="intro_empty" v-else>
							<img :src="require(`@/assets/blank.png`)" alt="" />
							<div>-- 暂无项目 --</div>
						</div>

						<div class="load_more_btn" :class="{active: showAll}" v-if="hiddenProjectsCount > 0"
							@click="showAllProjects">
							<span v-if="showAll">收起</span>
							<span v-else>展开更多（+{{hiddenProjectsCount}}）</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="fixed-btn top" @click="toTop()" v-if="!isMobile">
			<img :src="require(`@/assets/arrow.png`)">
		</div>
		<div class="fixed-btn back" @click="$router.go(-1)" v-if="!isMobile">
			<img :src="require(`@/assets/arrow.png`)">
		</div>

		<!-- 全屏图片查看器 -->
		<div class="lightbox" v-if="showLightbox">
			<button class="lightbox-close" @click="closeLightbox">×</button>
			<button class="lightbox-nav lightbox-prev" @click.stop="prevImage" :disabled="lightboxIndex === 0">
				<img :src="require(`@/assets/arrow.png`)" class="nav-arrow">
			</button>
			<button class="lightbox-nav lightbox-next" @click.stop="nextImage"
				:disabled="lightboxIndex === currentProjectImages.length - 1">
				<img :src="require(`@/assets/arrow.png`)" class="nav-arrow">
			</button>

			<div class="lightbox-content" @click.self="closeLightbox">
				<img v-lazy="currentProjectImages[lightboxIndex]" class="lightbox-image" @click.stop>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import db from "@/common/js/db.js";

	export default {
		name: 'intro',
		data() {
			return {
				hobbies: {},
				education: {},
				workExperience: {},
				skills: {},
				projects: {},
				selfEvaluation: {},
				showAll: false,
				isResume: true,
				activeTab: 'mixed',
				showLightbox: false,
				lightboxIndex: 0,
				currentProjectImages: []
			}
		},
		computed: {
			visibleProjects() {
				let num = this.activeTab === 'mixed' ? 3 : 2
				return this.showAll ? this.filteredProjects : this.filteredProjects.slice(0, num);
			},
			hiddenProjectsCount() {
				let num = this.activeTab === 'mixed' ? 3 : 2
				return this.filteredProjects.length - num;
			},
			filteredProjects() {
				return this.projects.content.filter(project => {
					const tagsItem = project.find(item => item.tip === '负责标签')
					let isUI = tagsItem.detail === 'UI'
					return tagsItem && (this.activeTab === 'mixed' ? !isUI : isUI)
				})
			},
			uiProjectsCount() {
				return this.projects.content.filter(project => {
					const tagsItem = project.find(item => item.tip === '负责标签');
					let isUI = tagsItem.detail === 'UI'
					return tagsItem && isUI
				}).length;
			},
			mixedProjectsCount() {
				return this.projects.content.length - this.uiProjectsCount
			},
			isMobile() {
				return window.innerWidth < 768; // 通常768px是移动和桌面的分界点
			}
		},
		created() {
			const dbData = db();
			const infos = dbData.info;
			this.isResume = dbData.type === 'resume'
			let hobbyTit = this.isResume ? '求职意向' : '个人爱好'
			let eduTit = this.isResume ? '教育背景' : 'Logo拆解'

			this.hobbies = infos.find(item => item.tit === hobbyTit) || {};
			this.education = infos.find(item => item.tit === eduTit) || {};
			this.workExperience = infos.find(item => item.tit === '工作经历') || {};
			this.skills = infos.find(item => item.tit === '职业技能') || {};
			this.projects = infos.find(item => item.tit === 'UI设计/前端主要项目') || {};
			let selfEvaluation = infos.find(item => item.tit === '自我评价') || {};
			this.selfEvaluation = selfEvaluation.content[0][0]
		},
		mounted() {
			this.mobileToTop()
			window.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
			window.removeEventListener('keydown', this.handleKeydown);
		},
		methods: {
			// 解决手机端强制横屏后，一进入页面，本页在最底部的BUG
			mobileToTop(){
				if(!this.isMobile){ return }
				this.$nextTick(()=>{
					this.$nextTick(() => {
						// 滚动条固定到定位元素位置
					    const tabElement = document.getElementById('top');
					    if (tabElement) {
					      tabElement.scrollIntoView({
					        behavior: 'auto',
					        inline: 'nearest'
					      });
					    }
					});
				})
			},
			getSkillLevel(score) {
				if (score > 85) return '精通';
				if (score >= 70) return '熟练';
				return '掌握';
			},
			showAllProjects() {
				this.showAll = !this.showAll;
				  if(!this.showAll){ return }
				  if(!this.isMobile){ return }
				  // 解决手机端横屏后，点击按钮，页面滚动位置不对的BUG
				  this.$nextTick(() => {
				    // 获取所有项目元素
				    const projectElements = document.querySelectorAll('.intro_job_block');
				    let num = this.activeTab === 'ui' ? 2 : 3
				    // 如果有4个或更多项目，滚动到第4个项目
				    if (projectElements.length >= num) {
				      projectElements[num-2].scrollIntoView({
				        behavior: 'auto',
				        block: 'start'
				      });
				    }
				    // 如果少于4个项目，滚动到最后一个项目
				    else if (projectElements.length > 0) {
				      projectElements[projectElements.length - 2].scrollIntoView({
				        behavior: 'auto',
				        block: 'start'
				      });
				    }
				  });
			},
			toTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			},
			changeTab(tab) {
				this.activeTab = tab;
				this.showAll = false;
				if(!this.isMobile){ return }
				// 解决手机端横屏后，点击按钮，页面滚动位置不对的BUG
				this.$nextTick(() => {
				    const tabElement = document.getElementById('tab');
				    if (tabElement) {
				      tabElement.scrollIntoView({
				        behavior: 'auto',
				        block: 'center'
				      });
				    }
				});
			},
			openProjectLightbox(project, imgIndex = 0) {
				if (this.isMobile) {
					this.$toast.info('手机端暂不支持预览，可移至“设计”页面查看')
					return
				}
				this.currentProjectImages = project
					.filter(item => item.img)
					.flatMap(item => item.img.map(pic => `./static/picImgs/${pic}`));
				
				if (this.currentProjectImages.length > 0) {
					this.lightboxIndex = imgIndex;
					this.showLightbox = true;
					document.body.style.overflow = 'hidden';
				}
			},
			closeLightbox() {
				this.showLightbox = false;
				document.body.style.overflow = '';
			},
			prevImage() {
				if (this.lightboxIndex > 0) {
					this.lightboxIndex--;
				}
			},
			nextImage() {
				if (this.lightboxIndex < this.currentProjectImages.length - 1) {
					this.lightboxIndex++;
				}
			},
			handleKeydown(e) {
				if (!this.showLightbox) return;
				if (e.key === 'Escape') {
					this.closeLightbox();
				} else if (e.key === 'ArrowLeft') {
					this.prevImage();
				} else if (e.key === 'ArrowRight') {
					this.nextImage();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import "../../common/less/index.less";

	@_light_blue: #E6F6FF;
	@_dark_blue: #231B6F;
	@_blue: #24A4EF;
	@_line_color: #E6E6F3;
	@_yellow: #FBCA7E;

	.intro {
		background: @_light_blue;
		min-height: 100vh;
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	.intro_img_1 {
		width: 47%;
		top: 0;
		left: 0;
		z-index: 1;
	}

	.intro_img_2 {
		position: absolute;
		top: 34vh;
		left: 37%;
		width: 7%;
		z-index: 2;
	}

	.intro_white_bg {
		position: absolute;
		right: -27%;
		top: -95vw;
		width: 120%;
		height: 150vw;
		background: #fff;
		border-radius: 50%;
		transform: rotate(-90deg);
		z-index: 0;
	}

	.intro_top_word_body {
		position: relative;
		z-index: 3;
		width: 47%;
		float: right;
		margin-top: 50px;
		margin-right: 6%;
	}

	.intro_name {
		color: @_blue;
		font-size: 36px;
		display: inline-block;
		vertical-align: bottom;
	}

	.intro_birth {
		border-left: 1px solid @_line_color;
		border-right: 1px solid @_line_color;
		padding: 0 15px;
		margin: 0 15px;
		width: 50px;
		display: inline-block;
		text-align: center;
		color: @_blue;
		vertical-align: middle;

		.sm_word {
			font-size: 9px;
			display: block;
			margin-top: -3px;
			font-weight: bold;
		}

		.lg_word {
			font-size: 22px;
			display: block;
			margin-top: -5px;
		}
	}

	.intro_content {
		color: #fff;
		display: inline-block;
		background: linear-gradient(90deg, @_blue, @_dark_blue);
		border-radius: 30px;
		padding: 8px 30px;
		font-size: 14px;
	}

	.intro_top_content {
		margin-top: 30px;
	}

	.intro_top_row {
		margin-top: 25px;

		@size: 32px;

		.left {
			width: @size;
			height: @size;
			line-height: @size;
			border-radius: 50%;
			background: lighten(@_light_blue, 2%);
			color: @_blue;
			border: 8px solid darken(@_light_blue, 5%);
			text-align: center;
			font-size: 18px;
			font-weight: bold;
		}

		.right {
			width: calc(100% - @size - 50px);
			margin-top: 5px;
			line-height: 35px;
			font-size: 18px;
			color: rgba(0, 0, 0, 0.9);
		}
	}

	.intro_others {
		clear: both;
		position: relative;
		z-index: 3;
	}

	.intro_img_3 {
		width: 6%;
		vertical-align: bottom;
	}

	.intro_img_3_wrap {
		text-align: right;
		margin: 0 13%;
	}

	.margin_side {
		margin: 0 7%;
	}

	.intro_middle_block {
		background: #fff;
		border-radius: 20px;
		padding: 50px 50px 35px 50px;
		width: 1/4.5*100%;
		box-shadow: 0 0 15px 15px rgba(35, 27, 111, 0.01);

		&:hover {
			box-shadow: none;
		}
	}

	.intro_title_1 {
		margin-bottom: 20px;
	}

	.intro_title_line {
		background: @_blue;
		height: 8px;
		width: 60px;
		border-radius: 6px;
		display: inline-block;
		margin-top: 12px;
	}

	.intro_title_txt {
		font-size: 30px;
		display: block;
	}

	.center {
		text-align: center;
	}

	.intro_img_4 {
		width: 70%;
		margin-top: 5px;
	}

	.intro_tag_wrap {
		margin-top: 10px;
		line-height: 37px;

		.left {
			color: #aaa;
			display: inline-block;
			width: 70px;
			font-size: 14px;
		}

		.right {
			font-size: 16px;
		}
	}

	.intro_bottom {
		margin-top: 250px;
		position: relative;
		background: @_dark_blue;
		padding-bottom: 1px;

		.intro_title_1 {
			color: #fff;
		}

		.intro_tag_wrap {
			.left {
				color: rgba(255, 255, 255, 0.5);
			}

			.right {
				color: #fff;
			}
		}
	}

	.intro_bottom_bg {
		position: absolute;
		background: @_dark_blue;
		width: 400vw;
		height: 400vw;
		border-radius: 50%;
		top: -3vw;
		left: -150%;
		z-index: 0;
	}

	.intro_resume {
		position: relative;
		z-index: 1;
	}

	.intro_title_2 {
		text-align: center;
		position: relative;
		margin-top: -100px;
		margin-bottom: 20px;

		.intro_title_1 {
			position: absolute;
			z-index: 2;
			top: 70px;
			left: 0;
			text-align: center;
			width: 100%;
		}

		.intro_title_txt {
			font-size: 45px;
		}
	}

	.intro_title_lg_word {
		font-size: 130px;
		color: rgba(255, 255, 255, 0.04);
		background: @_dark_blue;
		display: inline-block;
		padding: 0 5%;
	}

	.intro_title_inner {
		position: relative;
		z-index: 2;
	}

	.intro_title_2_line {
		position: absolute;
		border-radius: 10px;
		background: rgba(255, 255, 255, 0.04);
		width: 100%;
		height: 12px;
		z-index: 1;
		top: 50%;
		left: 0;
	}

	.intro_title_3 {
		color: #fff;
		font-size: 25px;
		margin-bottom: 30px;

		span {
			display: inline-block;
			vertical-align: middle;
		}
	}

	.intro_title_3_line {
		background: @_blue;
		width: 8px;
		height: 30px;
		border-radius: 10px;
		margin-right: 20px;
	}

	.intro_job_block {
		width: 1/3.5*100%;
		align-items: start;
	}

	.blue {
		color: @_blue !important;
		font-weight: bold;
		font-size: 18px !important;
	}

	.intro_skills {
		background: rgba(255, 255, 255, 0.1);
		border: 5px dashed rgba(255, 255, 255, 0.2);
		border-radius: 20px;
		margin: 50px 0;
		padding: 40px 60px 30px 60px;
	}

	.bar {
		background: #fff;
		height: 10px;
		border-radius: 10px;
		margin-top: 20px;
	}

	.bar_inner {
		background: @_blue;
		height: 10px;
		border-radius: 10px;
	}
	.intro_skills_wrap{
		flex-wrap: wrap;
		align-items: end;
	}

	.intro_skills_block {
		// display: inline-block;
		width: 1/5*100%;
		// margin-right: 1/5/2*100%;
		margin-top: 50px;
		margin: 0 1% 20px;

		// &:nth-child(4n) {
		// 	margin-right: 0;
		// }

		&.yellow {
			.blue {
				color: @_yellow !important;
			}

			.bar_inner {
				background: @_yellow;
			}

			.intro_tag {
				background: lighten(@_yellow, 20%);
				color: darken(@_yellow, 14%);
			}
		}
	}

	.intro_tag {
		background: lighten(@_blue, 38%);
		color: @_blue;
		font-size: 12px;
		border-radius: 4px;
		padding: 5px 15px;
		margin-left: 10px;
		font-weight: bold;
	}

	.intro_items {
		.item_title{
			justify-content: start;
		}
		.intro_job_block {
			width: 100%;
			border-bottom: 5px dashed rgba(255, 255, 255, 0.2);
			margin-bottom: 40px;
			padding-bottom: 30px;

			&:last-child {
				border-bottom: none;
			}
		}
	}

	.load_more_btn {
		background: lighten(@_dark_blue, 55%);
		color: @_dark_blue;
		text-align: center;
		font-size: 12px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		padding: 5px 0;
		margin: -30px 0 80px 0;
		cursor: pointer;
		transition: all 0.3s;

		&:hover {
			background: lighten(@_dark_blue, 45%);
		}

		&.active {
			background: rgba(255, 255, 255, 0.2);
			color: @_yellow;
		}
	}

	.word_video {
		width: 35%;
		height: 400px;
		margin-left: 50px;
		border-radius: 10px;
		background: rgba(255, 255, 255, 0.1);
	}

	.project_img_wrap {
		width: 190px;
		max-height: 300px;
		overflow: hidden;
		border-radius: 0 8px 8px 8px;
		display: inline-block;
		vertical-align: top;
		margin-top: 15px;
		margin-right: 15px;
		transition: all 0.3s;
		cursor: zoom-in;

		&:hover,
		&:active {
			transform: scale(1.1, 1.1);
		}
	}

	.project_img {
		width: 100%;
		// min-height: 100%;
		height: inherit;
		border-radius: 0 8px 8px 8px;
		vertical-align: top;
	}

	.short {
		width: 80%;
	}

	.tag {
		width: 22px;
		height: 22px;
		line-height: 22px;
		text-align: center;
		color: #fff;
		border-radius: 50%;
		display: inline-block;
		font-size: 12px;
		font-weight: bold;
		margin-right: 5px;

		&.yellow {
			background: #e79d26;
		}

		&.green {
			background: #71ca2c;
		}

		&.tag_blue {
			background: #9560ff;
		}
	}

	.fixed-btn {
		position: fixed;
		right: 20px;
		z-index: 10;
		background: rgba(255, 255, 255, 0.3);

		&.top {
			bottom: 70px;
			background: #fbc977;

			img {
				transform: rotate(90deg);
			}
		}

		&.back {
			background: #8cc8ef;
			bottom: 20px;
		}
	}

	.intro_tab_wrap {
		margin-left: 10px;
		span {
			display: inline-block;
			padding: 10px 5px;
			color: #fff;
			background: #eeb76a;
			cursor: pointer;
			font-size: 14px;
			font-weight: bold;
			opacity: 0.7;
			text-align: center;
			width: 10vw;

			&:first-child {
				border-top-left-radius: 30px;
				border-bottom-left-radius: 30px;
			}

			&:last-child {
				border-top-right-radius: 30px;
				border-bottom-right-radius: 30px;
			}

			&.active {
				background: #24A4EF;
				opacity: 1;
			}
		}
	}

	.intro_empty {
		text-align: center;
		background: rgba(255, 255, 255, 0.1);
		border: 5px dashed rgba(255, 255, 255, 0.2);
		border-radius: 20px;
		margin-bottom: 40px;
		padding: 40px 60px 50px 60px;
		font-size: 16px;
		color: rgba(255, 255, 255, 0.5);

		img {
			width: 25%;
		}
	}

	.intro_job_body {
		&.two {
			.row_space_between;
			flex-wrap: wrap;

			.intro_job_block {
				width: 48%;

				&:last-child {
					border-bottom: 5px dashed rgba(255, 255, 255, 0.2);
				}
			}
		}
	}

	/* 新增轮播图样式 */
	.lightbox {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.9);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		cursor: zoom-out;
		backdrop-filter: blur(5px);
	}

	.lightbox-content {
		position: relative;
		width: 85%;
		height: inherit;
		display: flex;
		justify-content: center;
		align-items: start;
		overflow: auto;
	}

	.lightbox-image {
		width: 100%;
		object-fit: contain;
		cursor: default;
		margin: 40px 0;
	}

	.lightbox-close {
		position: fixed;
		top: 20px;
		right: 20px;
		background: none;
		border: none;
		color: white;
		font-size: 40px;
		cursor: pointer;
		z-index: 1001;
		padding: 10px 20px;

		&:hover {
			opacity: 0.8;
		}
	}

	.lightbox-nav {
		position: fixed;
		top: 50%;
		transform: translateY(-50%);
		background: rgba(0, 0, 0, 0.5);
		border: none;
		color: white;
		font-size: 30px;
		width: 60px;
		height: 60px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		z-index: 1001;

		&:hover {
			background: rgba(0, 0, 0, 0.8);
		}

		&[disabled] {
			opacity: 0.3;
			cursor: not-allowed;
		}
	}

	.lightbox-prev {
		left: 20px;

		.nav-arrow {
			transform: rotate(0deg);
		}
	}

	.lightbox-next {
		right: 20px;

		.nav-arrow {
			transform: rotate(180deg);
		}
	}

	.nav-arrow {
		width: 30px;
		height: 30px;
	}

	@media screen and (max-width: 1440px) {
		.intro_birth{
			margin: 0 10px;
			padding: 0 5px;
		}
		.intro_content{
			padding: 8px 15px;
		}
		.intro_white_bg{
			top: -92vw;
		}
	}
	@media screen and (max-width: 1367px) {
		.intro_white_bg{
			top: -90vw;
		}
	}
	/* 手机端横屏适配 */
	@media screen and (orientation:portrait) {
		.intro {
			width: 100vh;
			overflow-y: hidden;
			transform-origin: 0 0;
			transform: rotateZ(90deg) translateY(-100%);
		}

		.lightbox {
			transform: rotate(0deg) translateY(0);
			transform-origin: 0 0;
			width: 100vh;
			height: 100vw;
		}

		.lightbox-content {
			width: 75%;
		}

		.lightbox-image {
			margin: 20px 0;
		}

		.intro_name {
			font-size: 22px;
		}

		.intro_birth {
			padding: 0 0;
			margin: 0 15px;

			.lg_word {
				font-size: 14px;
			}
		}

		.intro_content {
			font-size: 12px;
			padding: 5px 10px;
			width: 53%;
		}

		.intro_top_content {
			margin-top: 20px;
		}

		.intro_top_row {
			margin-top: 20px;
			@size: 20px;

			.left {
				width: @size;
				height: @size;
				line-height: @size;
				font-size: 14px;
				border-width: 5px;
			}

			.right {
				width: calc(100% - @size - 30px);
				margin-top: 0;
				font-size: 11px;
				line-height: 15px;
				opacity: 0.7;
			}
		}

		.intro_white_bg {
			width: 120%;
			height: 80vh;
			right: -30%;
			top: -40vh;
			transform: rotate(0deg);
		}

		.intro_middle_block {
			padding: 20px;
			width: 25%;
		}

		.intro_title_1 {
			margin-bottom: 5px;
		}

		.intro_title_txt {
			font-size: 20px;
			margin-bottom: -5px;
		}

		.intro_title_line {
			width: 30px;
			height: 4px;
		}

		.intro_tag_wrap {
			margin-bottom: 5px;
			line-height: 25px;

			.left {
				margin-bottom: 3px;
			}

			.right {
				font-size: 14px;
			}
		}

		.intro_skills_block {
			width: 30%;
			// margin-right: 4%;
			// margin-top: 25px;

			// &:nth-child(4n) {
			// 	margin-right: 4%;
			// }

			// &:nth-child(3n) {
			// 	margin-right: 0;
			// }
		}

		.intro_skills {
			padding: 30px;
		}

		.intro_bottom {
			margin-top: 150px;
		}

		.intro_title_3 {
			margin-bottom: 30px;
		}

		.intro_skills {
			margin: 40px 0;
		}

		.intro_title_2 {
			margin-bottom: 0;
		}

		.intro_job_body {
			flex-wrap: wrap;
			align-items: baseline;
		}

		.intro_job_block {
			align-items: start;
			width: 45%;

			&:last-child {
				width: 100%;
				margin-top: 40px;
			}
		}

		.intro_img_4 {
			width: 95%;
		}

		.intro_img_3_wrap {
			margin-top: 0;
		}

		.intro_tab_wrap {
			span {
				width: 15vh;
			}
		}

		.intro_tag {
			margin-left: 5px;
		}

		.project_img_wrap {
			width: 30%;
			min-width: 160px;
		}

		.intro_job_body {
			&.two {
				.row_space_between;
				flex-wrap: wrap;

				.intro_job_block {
					width: 100%;

					&:last-child {
						margin-top: -5px;
						border-bottom: none;
					}
				}
			}
		}
		.intro_img_2{
			top: 16vh;
		}
		.intro_top_word_body{
			margin-top: 20px;
		}
		
	}
	
	// 适配手机端非全屏浏览器
	@media screen and (min-height: 600px) and (max-height: 780px) and (max-width: 768px) {
		.intro_white_bg{
			top: -33vh;
		}
		.intro_img_3_wrap{
			padding-top: 20px;
		}
		.intro_top_word_body{
			margin-top: 20px;
			font-size: 10px;
			vertical-align: middle;
		}
		.intro_birth{
			width: 40px;
			margin: 0 5px;
		}
		.intro_tab_wrap span{
			width: 13vh;
		}
	}
	// 适配手机端非全屏浏览器(页面高度更短)
	@media screen and (min-height: 600px) and (max-height: 680px) and (max-width: 768px) {
		.intro_skills_block{
			width: 45%;
		}
		.intro_title_3{
			font-size: 20px;
		}
		.intro_title_3_line{
			margin-right: 5px;
		}
		.intro_tab_wrap span{
			width: 15vh;
			padding: 7px 5px;
		}
		.intro_white_bg{
			top: -24vh;
		}
		.intro_top_word_body {
			width: 49%;
			margin-right: 4%;
		}
		.intro_content{
			width: 50%;
			font-size: 10px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/intro/intro.vue